import React from 'react'
import { Helmet } from 'react-helmet'

export default function HelmetDynamic({
  title,
  description,
  path,
}: {
  title?: string
  description: string
  path: string
}) {
  const finalTitle = title === undefined ? 'KFamily' : `${title} - KFamily`

  return (
    <Helmet>
      <meta charSet="utf-8" />
      <title>{finalTitle}</title>

      <meta name="description" content={description} />

      <meta property="og:type" content="website" />
      <meta property="og:url" content={`https://kfamily.pt${path}`} />
      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={description} />
      <meta
        property="og:image"
        content="https://res.cloudinary.com/kfamily-is1/image/upload/v1741437047/Instagram_post_-_5_ftut5f.png"
      />
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={`https://kfamily.pt${path}`} />
      <meta property="twitter:title" content={finalTitle} />
      <meta property="twitter:description" content={description} />
      <meta
        property="twitter:image"
        content="https://res.cloudinary.com/kfamily-is1/image/upload/v1741437047/Instagram_post_-_5_ftut5f.png"
      />

      <meta name="robots" content="index, follow" />

      <link rel="canonical" href={`https://kfamily.pt${path}`} />
    </Helmet>
  )
}
